import React from 'react'
import ReactDOM from 'react-dom'
import './WalletApiIframeModal.scss'

export const WalletApiIframeModal = ({ iframeUrl, onClose }) => {
  if (!iframeUrl) return null

  return ReactDOM.createPortal(
    <div className="walletapi-iframe-modal">
      <div className="overlay" onClick={onClose}>
        <div className="container" onClick={(e) => e.stopPropagation()}>
          <button className="close" onClick={onClose} aria-label="Close">
            x
          </button>

          <iframe src={iframeUrl} title="Payment" className="iframe" />
        </div>
      </div>
    </div>,
    document.body
  )
}
